module.exports = __webpack_public_path__ + "images/image_default_next_scene.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/image_default_next_scene.svg
// module id = 1457
// module chunks = 0